import moment from 'moment';
/**
 * Feed filter state. Structured as so:
 *
 * 	// the network specific feed filter
 * }
 */
const getInitialState = function () {
  return {
    filter_text: '',
    media_type: [],
    selectedLanguages: [],
    tagSlug: null,
    presenter: null,
    date_publish: '0', // 0 for show all
    dates: {
      startDate: '',
      endDate: '',
    },
    chosen_network: '0', // 0 for show all
  };
};

export default {
  namespaced: true,

  state: getInitialState(),

  getters: {
    // returns true if any of the filter settings are different from the default
    isAnyFilterSelected: function (state) {
      // this seems to be working great:
      return JSON.stringify(state) !== JSON.stringify(getInitialState());
    },

    // a utility getter that will create the Feed Request based on the filters set.
    getRequest: function (state) {
      let request = {};
      request.media_type = state.media_type;
      request.query = state.filter_text;
      request.tag = state.tagSlug ? (Array.isArray(state.tagSlug) ? (state.tagSlug.map(function (t) {
        return t.slug;
      })) : [state.tagSlug.slug]) : null;
      request.presenter = state.presenter ? state.presenter.id : null;

      /*request.languages = state.selectedLanguages.map(function (l) {
        return l.id;
      });*/

      if (state.date_publish != '' && state.date_publish != '0') {
        request.dates = {
          startDate: moment().subtract(state.date_publish, 'days').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        };
      } else {
        // just use what the state has by default
        request.dates = state.dates;
      }

      if (state.chosen_network != '' && state.chosen_network != '0') {
        //const networks = rootGetters['network/myManagedNetworks'].concat(rootGetters['network/myNetworks']).concat(rootGetters['network/discoverNetworks']);
        //const validNetworks = networks.filter(network => network && network.slug);
        //const matchedNetworks = networks.filter(network => network.slug.includes(state.chosen_network.slug));
        //request.network = matchedNetworks.map(network => network);
        request.network = state.chosen_network;
      } else {
        request.network = null; // load all networks
      }

      return request;
    },
  },

  mutations: {
    // we must follow the RESET_STATE convention
    RESET_STATE(state) {
      Object.assign(state, getInitialState());
    },

    filter_text(state, payload) {
      state.filter_text = payload;
    },
    media_type(state, payload) {
      state.media_type = payload;
    },
    tagSlug(state, payload) {
      state.tagSlug = payload;
    },
    presenter(state, payload) {
      state.presenter = payload;
    },
    selectedLanguages(state, payload) {
      state.selectedLanguages = payload;
    },
    date_publish(state, payload) {
      state.date_publish = payload;
      if (state.date_publish == '') {
        // no op
      } else if (state.date_publish == '0') {
        state.dates.startDate = '';
        state.dates.endDate = '';
      } else {
        state.dates.startDate = moment().subtract(state.date_publish, 'days').format('YYYY-MM-DD');
        state.dates.endDate = moment().format('YYYY-MM-DD');
      }
    },
    dates(state, payload) {
      state.dates = payload;
    },
    chosen_network(state, payload) {
      if (payload != '') {
        state.chosen_network = payload;
      }
    },
  },

  actions: {
    /*
    if (this.$auth.auth) {
      this.$store.dispatch('content_language/loadMyPreferredLanguages').then(languages => {
        this.search.selectedLanguages = languages;
      });
    }
    this.search.tagSlug = this.getTagNameFromRouteQuery();
    */
  },
};
